import(/* webpackMode: "eager", webpackExports: ["FaqPageContent"] */ "/vercel/path0/src/components/inbound-gpt/product-pages.tsx");
